var exports = {
  "q": "MessageTaskBadge.module__badge___RGRyM0",
  "O": "MessageTaskBadge.module__dot___RGRyM0",
};

module.exports = exports;
